import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { UseAllState } from "../Context";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { GiTeacher } from "react-icons/gi";
import { MdLogout } from "react-icons/md";
import { IoBarChartOutline } from "react-icons/io5";
import { LuClipboardList } from "react-icons/lu";
import Modal from "react-modal";

import user from "../assets/icon/user.svg";
import adduser from "../assets/icon/user-add.svg";
import edituser from "../assets/icon/user-edit.svg";
import Attendance from "../assets/icon/note.svg";
import addcourse from "../assets/icon/add-circle.svg";
import editcourse from "../assets/icon/edit.svg";
import Financialaffairs from "../assets/icon/Financialaffairs.svg";
import UserEdit from "../assets/icon/edit-profile.svg";

const containerVariants = {
  hidden: { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: "easeOut", staggerChildren: 0.1 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0 },
};

const dropdownVariants = {
  hidden: { opacity: 0, height: 0, marginTop: 0 },
  visible: {
    opacity: 1,
    height: "auto",
    marginTop: 8,
    transition: { duration: 0.3 },
  },
};

const Dashboard = (props) => {
  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_URL;

  const [showCourseDropDown, setShowCourseDropDown] = useState(false);
  const [showStudentDropDown, setShowStudentDropDown] = useState(false);
  const [showTeacherDropDown, setShowTeacherDropDown] = useState(false);
  const [showFinancialDropDown, setShowFinancialDropDown] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { firstName, lastName, image, setShownav, changewelcomepage } =
    UseAllState();

  const handlegotoeditpage = () => {
    setShownav(false);
    navigate("/Mainpage/EditProfile");
  };

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const handlelogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const customStyles = {
    content: {
      borderRadius: "16px",
      margin: "auto",
      padding: "0",
      border: "none",
      width: "85%",
      maxWidth: "320px",
      height: "180px",
      background: "white",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.55)",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      className="flex flex-col h-full bg-gray-200 text-gray-900"
    >
      {/* Avatar */}
      <motion.div
        variants={itemVariants}
        className="flex flex-col items-center mt-8 mb-6 px-4"
      >
        <div
          onClick={handlegotoeditpage}
          className="relative w-24 h-24 rounded-full border-[0.186em] border-gray-900 cursor-pointer overflow-hidden group shadow-xl"
        >
          {image ? (
            <img
              src={`${API_BASE}/${image}`}
              alt="profile"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-300">
              <FaUser className="text-gray-700 w-12 h-12" />
            </div>
          )}
        </div>
      </motion.div>

      {/* Menu */}
      <div className="flex-1 px-4 space-y-3 overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-300 scrollbar-thumb-rounded-full hover:scrollbar-thumb-gray-700 transition-colors">
        <motion.div variants={itemVariants}>
          <MenuItem
            icon={<img src={UserEdit} className="w-6 h-6" />}
            label="ویرایش پروفایل"
            onClick={() => {
              props.myclick(0);
              changewelcomepage();
            }}
          />
        </motion.div>

        <motion.div variants={itemVariants}>
          <MenuItem
            icon={<img src={user} className="w-6 h-6" />}
            label="اساتید"
            onClick={() => setShowTeacherDropDown(!showTeacherDropDown)}
            isActive={showTeacherDropDown}
          />
          <motion.div
            initial="hidden"
            animate={showTeacherDropDown ? "visible" : "hidden"}
            variants={dropdownVariants}
          >
            {showTeacherDropDown && (
              <div className="pr-10 space-y-2">
                <SubMenuItem
                  icon={<img src={adduser} className="w-4 h-4" />}
                  label="ثبت استاد"
                  onClick={() => {
                    props.myclick(1);
                    changewelcomepage();
                  }}
                />
                <SubMenuItem
                  icon={<img src={edituser} className="w-4 h-4" />}
                  label="لیست استاد"
                  onClick={() => {
                    props.myclick(6);
                    changewelcomepage();
                  }}
                />
              </div>
            )}
          </motion.div>
        </motion.div>

        <motion.div variants={itemVariants}>
          <MenuItem
            icon={<FaUser className="w-6 h-6" />}
            label="دانشجویان"
            onClick={() => setShowStudentDropDown(!showStudentDropDown)}
            isActive={showStudentDropDown}
          />
          <motion.div
            initial="hidden"
            animate={showStudentDropDown ? "visible" : "hidden"}
            variants={dropdownVariants}
          >
            {showStudentDropDown && (
              <div className="pr-10 space-y-2">
                <SubMenuItem
                  icon={<img src={adduser} className="w-4 h-4" />}
                  label="ثبت دانشجو"
                  onClick={() => {
                    props.myclick(2);
                    changewelcomepage();
                  }}
                />
                <SubMenuItem
                  icon={<img src={edituser} className="w-4 h-4" />}
                  label="لیست دانشجو"
                  onClick={() => {
                    props.myclick(5);
                    changewelcomepage();
                  }}
                />
              </div>
            )}
          </motion.div>
        </motion.div>

        <motion.div variants={itemVariants}>
          <MenuItem
            icon={<GiTeacher className="w-6 h-6" />}
            label="دوره‌ها"
            onClick={() => setShowCourseDropDown(!showCourseDropDown)}
            isActive={showCourseDropDown}
          />
          <motion.div
            initial="hidden"
            animate={showCourseDropDown ? "visible" : "hidden"}
            variants={dropdownVariants}
          >
            {showCourseDropDown && (
              <div className="pr-10 space-y-2">
                <SubMenuItem
                  icon={<img src={addcourse} className="w-4 h-4" />}
                  label="ثبت دوره"
                  onClick={() => {
                    props.myclick(3);
                    changewelcomepage();
                  }}
                />
                <SubMenuItem
                  icon={<img src={editcourse} className="w-4 h-4" />}
                  label="لیست دوره"
                  onClick={() => {
                    props.myclick(4);
                    changewelcomepage();
                  }}
                />
              </div>
            )}
          </motion.div>
        </motion.div>

        <motion.div variants={itemVariants}>
          <MenuItem
            icon={<img src={Financialaffairs} className="w-6 h-6" />}
            label="امور مالی"
            onClick={() => setShowFinancialDropDown(!showFinancialDropDown)}
            isActive={showFinancialDropDown}
          />
          <motion.div
            initial="hidden"
            animate={showFinancialDropDown ? "visible" : "hidden"}
            variants={dropdownVariants}
          >
            {showFinancialDropDown && (
              <div className="pr-10 space-y-2">
                <SubMenuItem
                  icon={<IoBarChartOutline className="w-4 h-4" />}
                  label="تراز مالی"
                  onClick={() => {
                    props.myclick(8);
                    changewelcomepage();
                  }}
                />
                <SubMenuItem
                  icon={<LuClipboardList className="w-4 h-4" />}
                  label="لیست بدهکاران"
                  onClick={() => {
                    props.myclick(9);
                    changewelcomepage();
                  }}
                />
              </div>
            )}
          </motion.div>
        </motion.div>

        <motion.div variants={itemVariants}>
          <MenuItem
            icon={<img src={Attendance} className="w-6 h-6" />}
            label="حضور و غیاب"
            onClick={() => {
              props.myclick(7);
              changewelcomepage();
            }}
          />
        </motion.div>
      </div>

      {/* Logout */}
      <div className="p-4 border-t border-white/20">
        <button
          onClick={openModal}
          className="w-full py-3 text-red-600 font-bold text-base flex items-center justify-center gap-2"
        >
          <MdLogout className="w-5 h-5" /> خروج از حساب
        </button>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <div className="flex flex-col items-center justify-center h-full px-6 text-center bg-gray-200 font-iranSansNormal">
          <p className="text-gray-800 text-lg font-semibold">
            آیا از خروج خود اطمینان دارید؟
          </p>
          <div className="flex gap-4 mt-8">
            <button
              onClick={handlelogout}
              className="px-8 py-3 rounded-lg bg-red-600/90 text-white text-sm font-medium"
            >
              بله
            </button>
            <button
              onClick={closeModal}
              className="px-8 py-3 rounded-lg bg-gray-700 hover:bg-gray-600 text-white text-sm font-medium"
            >
              خیر
            </button>
          </div>
        </div>
      </Modal>
    </motion.div>
  );
};

const MenuItem = ({ icon, label, onClick, isActive }) => (
  <div
    onClick={onClick}
    className={`flex items-center gap-3 cursor-pointer p-3 rounded-xl transition-all ${
      isActive
        ? "bg-gray-300/100 border-r-4 border-gray-900"
        : "hover:bg-gray-300/100"
    }`}
  >
    {icon}
    <p className="font-bold text-base">{label}</p>
  </div>
);

const SubMenuItem = ({ icon, label, onClick }) => (
  <div
    onClick={onClick}
    className="flex items-center gap-2 cursor-pointer p-2 rounded-lg hover:bg-gray-300/100 transition-all"
  >
    {icon}
    <p className="font-medium text-sm text-gray-800">{label}</p>
  </div>
);

export default Dashboard;
